module.exports = __webpack_public_path__ + "static/media/pintodamadrugada.16566ce1.mp3";